<nav class="main-header navbar navbar-expand navbar-white navbar-light sticky-top">
  <!-- Left navbar links -->
  <ul class="navbar-nav ggPrompt">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="" role="button"><i class="fas fa-bars"></i></a>
    </li>

    <!-- test menu -->
    <section id="ktd" *ngIf="showNewMenu">
      <button class="homebtn"><i class="fas fa-home"></i> </button>
      <div class="dropdown">
        <button class="dropbtn"><i class="far fa-chart-bar"></i> Dashboard <i class="fas fa-angle-down"></i> </button>
        <div class="dropdown-content">
          <a href="#">BRD</a>
          <a href="#">ส่วน</a>
          <a href="#">โซน</a>
          <a href="#">นอส.</a>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn"><i class="far fa-address-card"></i> KPI <i class="fas fa-angle-down"></i> </button>
        <div class="dropdown-content">
          <a href="#">นอส.</a>
          <a href="#">เขต</a>
          <a href="#">ส่วน</a>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn"><i class="fas fa-tree"></i> แปลงอ้อย <i class="fas fa-angle-down"></i> </button>
        <div class="dropdown-content">
          <a href="#">Link 1</a>
          <a href="#">Link 2</a>
          <a href="#">Link 3</a>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn"><i class="fas fa-database"></i> สนับสนุน <i class="fas fa-angle-down"></i> </button>
        <div class="dropdown-content">
          <a href="#">Link 1</a>
          <a href="#">Link 2</a>
          <a href="#">Link 3</a>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn"><i class="fas fa-money-check-alt"></i> สินเชื่อ <i class="fas fa-angle-down"></i>
        </button>
        <div class="dropdown-content">
          <a href="#">Link 1</a>
          <a href="#">Link 2</a>
          <a href="#">Link 3</a>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn"><i class="fas fa-truck-loading"></i> ฤดูหีบ <i class="fas fa-angle-down"></i> </button>
        <div class="dropdown-content">
          <a href="#">Link 1</a>
          <a href="#">Link 2</a>
          <a href="#">Link 3</a>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn"><i class="fas fa-print"></i> รายงาน <i class="fas fa-angle-down"></i> </button>
        <div class="dropdown-content">
          <a href="#">Link 1</a>
          <a href="#">Link 2</a>
          <a href="#">Link 3</a>
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn"><i class="fas fa-bar"></i> แผนก <i class="fas fa-angle-down"></i> </button>
        <div class="dropdown-content">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            ธรุการเขต
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="#">Action</a></li>
            <li><a class="dropdown-item" href="#">Another action</a></li>
          </ul>
          <a href="#">วิชาการ</a>
          <a href="#">ประชาสัมพันธ์</a>
          <a href="#">บัญชีการเงิน</a>
          <a href="#">ออดิต</a>
          <a href="#">สารสนเทศฯ</a>
        </div>
      </div>
    </section>

    <!-- <form #frm_setyear="ngForm">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">ปีการผลิต</span>
        </div>
        <select #sYear="ngModel" ngModel name="sYear" 
          (change)="setYear(frm_setyear.value)"
          [(ngModel)]="yearSelected" 
          class="form-control">
          <option value="" disabled>++เลือกปี++</option>
          <option *ngFor="let i of yearSelect" [value]="i.yearCr">{{ i.yearlb }}</option>
        </select>
      </div>
    </form> -->
    <!-- <li class="nav-item ml-2">
      <a href="https://docs.google.com/document/d/1oSiZMKgLaiBAN8PeJWa68RuwRCk85klRlQGyU6lCUDI/edit?usp=sharing"
        target="_blank"
        rel="noopener noreferrer"
        style="color: blue"><small>คู่มือการใช้งาน</small></a>
    </li> -->

    <!-- การแจ้งเตือน มีข้อมูลจากออดิต ให้ ผจก.ดำเนินการตรวจสอบ แก้ไข -->
    <!-- <li class="nav-item d-none d-sm-inline-block">
      <div class="alert alert-danger mr-2">
         <strong>แจ้งเตือน!</strong> มีรายการที่ต้องตรวจสอบ/แก้ไข จากออดิต ที่ท่านยังไม่ได้ดำเนินการให้เสร็จสิ้น
       </div>
    </li> -->

    <!-- <li class="nav-item d-none d-sm-inline-block">
      <a href="./supporter" (click)="false" class="nav-link">หน้าแรก</a>
    </li> -->
  </ul>
  <!-- <ul class="navbar-nav ml-auto">

      <li class="nav-item d-none d-sm-inline-block">

         <div >
            <label style="font-family: 'Sarabun', sans-serif; font-size: medium;" *ngFor="let item of topbardata">
               อ้อยประเมิน <span class="badge badge-primary"> {{item.Assess | number}} </span>  ตัน
               อ้อยประเมิน 15 ม.ค. <span class="badge badge-primary">{{item.Assess_2 | number}}</span>
               เข้าหีบแล้ว <span class="badge badge-success">{{item.canein | number}}</span> ตัน
               <span class="badge badge-success">{{item.pc_canein | number}}</span> %
               </label> <br>

            <label style="font-family: 'Sarabun', sans-serif; font-size: medium;" *ngFor="let item of zonedata">  &nbsp; &nbsp;
               เขต {{item.supzone}}  <span class="badge badge-info">{{item.Assess | number}} </span>
               อ้อยประเมิน 15 ม.ค. <span class="badge badge-info">{{item.Assess_2 | number}}</span>
               เข้าหีบแล้ว <span class="badge badge-success">{{item.canein | number}}</span> ตัน
               <span class="badge badge-success">{{item.pc_canein | number}}</span> %
            </label>
         </div>
      </li>

   </ul>    -->

  <ul class="navbar-nav ml-auto" *ngIf="datanoti != null">
    <li class="nav-item dropdown" *ngFor="let item of datanoti">
      <a class="nav-link" data-toggle="dropdown">
        <i class="far fa-bell"></i>
        <span class="badge badge-warning navbar-badge">{{ item.ERcnt_y + item.ERcnt_ny }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
        <span class="dropdown-item dropdown-header">
          <span class="badge badge-warning"><i class="far fa-bell"></i></span>
          {{ item.ERcnt_y + item.ERcnt_ny }} Notifications</span>
        <!-- <div class="dropdown-divider"></div>
         <a class="dropdown-item">
         <i class="fas fa-envelope mr-2"></i> 4 new messages
         <span class="float-right text-muted text-sm">3 mins</span>
         </a> -->
        <div class="dropdown-divider"></div>
        <!-- <a class="dropdown-item">
         <i class="fas fa-users mr-2"></i> {{item.ERcnt_y}} แปลงปลูกเสร็จ
         <span class="badge badge-success right"><i class="fa fa-check"></i></span>
         <span class="float-right text-muted text-sm">12 hours</span>
         </a> -->
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" [routerLink]="['/reportnotify']" routerLinkActive="active" target="_blank">
          <i class="fas fa-file mr-2"></i> {{ item.ERcnt_ny }} แปลงปลูกไม่เสร็จ
          <span class="badge badge-danger right"><i class="fa fa-times"></i></span>
          <!-- <span class="float-right text-muted text-sm">2 days</span> -->
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item dropdown-footer">ดูการแจ้งเตือนทั้งหมด</a>
      </div>
    </li>

  </ul>
  <ul class="navbar-nav ml-auto">
    <li class="nav-item">
      <div [matMenuTriggerFor]="menu" class="d-flex flex-row d-flex align-items-center">
        <img class="img-circle" src={{userdata.suppic_url}} alt="User Image" height="45px">
        <div class="flex justify-center items-center">
          <span style="color: black;"> {{userdata.supcode}} : {{userdata.supname}} </span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
      </div>
      <!--<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon> </button>-->
      <mat-menu #menu="matMenu">
        <button mat-menu-item [routerLink]="['/myprofile']">
          <mat-icon>settings</mat-icon>
          <span>แก้ไขข้อมูลส่วนตัว</span>
        </button>
        <button mat-menu-item (click)="Logout()">
          <mat-icon style="color: red;">logout</mat-icon>
          <span>ออกจากระบบ</span>
        </button>
      </mat-menu>

    </li>
  </ul>

</nav>

<div class="modal fade" id="openmodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          ระบบที่สามารถใช้งานได้แล้วในตอนนี้
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>ระบบตรวจสอบงวดงาน KPI</p>
        <p>พื้นที่ปลูก 64/65</p>
        <p>เกรดแปลง</p>
        <p>แบบติดตามกิจกรรมแปลงอ้อย ในเมนูปี 64/65</p>
        <p style="color: red">
          เมนูรายการตรวจสอบ สำหรับผู้จัดการ หัวหน้าเขต หัวหน้าส่วน ผู้อำนวยการ
        </p>
        <p>บันทึกกิจกรรมแปลง 64/65</p>
        <p>อนุมัติปุ๋ย 3</p>
        <p>
          <a href="https://docs.google.com/document/d/1oSiZMKgLaiBAN8PeJWa68RuwRCk85klRlQGyU6lCUDI/edit?usp=sharing"
            target="_blank">คู่มือการใช้</a>
          บันทึกกิจกรรมแปลง 64/65
        </p>
      </div>
    </div>
  </div>
</div>